export default {
	'mainNav.addFunds': 'Add Funds',
	'mainNav.accounts': 'Accounts',
	'mainNav.allReports': 'All Reports',
	'mainNav.assignments': 'Assignments',
	'mainNav.calendar': 'Calendar',
	'mainNav.chatWithUs': 'Chat with us',
	'mainNav.configureNotificationsSettings': 'You may configure your notifications settings <a href="/mysettings/notifications"> here</a>.',
	'mainNav.contactManager': 'Contact Manager',
	'mainNav.dashboard': 'Dashboard',
	'mainNav.findTalent': 'Find Talent',
	'mainNav.findWork': 'Find Work',
	'mainNav.loading': 'loading...',
	'mainNav.myProfile': 'My Profile',
	'mainNav.myWork': 'My Work',
	'mainNav.newAssignments': 'New Assignments',
	'mainNav.newReport': 'New Report',
	'mainNav.noNewNotifications': 'No new notifications.',
	'mainNav.orgModeUpdateFail': 'There was a problem saving your org. mode.',
	'mainNav.overview': 'Overview',
	'mainNav.payments': 'Payments',
	'mainNav.projects': 'Projects',
	'mainNav.ratings': 'Ratings',
	'mainNav.realtime': 'Realtime',
	'mainNav.recruiting': 'Recruiting',
	'mainNav.reports': 'Reports',
	'mainNav.startChat': 'How can I help you today?',
	'mainNav.surveys': 'Surveys',
	'mainNav.talent': 'Talent',
	'mainNav.talentPools': 'Labor Clouds',
	'mainNav.talentProfile': 'Talent Profile',
	'mainNav.test': 'Tests',
	'mainNav.work': 'Work',
	'mainNav.workerServices': 'Worker Services',
	'mainNav.workUpload': 'WorkUpload™'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/main-nav.js